import React from 'react';
import ReactDOM from 'react-dom';

import Box from '../src/Components/Box.js';

import '../src/CSS/index.css';
import '../src/CSS/Box.css'


  ReactDOM.render(
  <React.StrictMode>
  <Box />
  </React.StrictMode>,
  document.getElementById('react')
);

